var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-devinder"},[_c('div',{staticClass:"tab-devinder__main-info"},[_vm._t("main")],2),_c('div',{staticClass:"tab-devinder__gallery"},[_vm._t("gallery")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }